module.exports = __webpack_public_path__ + "static/media/default-video.ab82ad02.png";